/**
 * Utility functions for workspace status handling
 */

/**
 * Get Tailwind CSS classes for workspace status badge
 */
function getWorkspaceStatusColor(status: string): string {
    switch (status) {
        case "running":
            return "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400";
        case "stopped":
            return "bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-400";
        case "provisioning":
        case "starting":
            return "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400";
        case "stopping":
            return "bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400";
        case "error":
            return "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400";
        default:
            return "bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-400";
    }
}

export { getWorkspaceStatusColor };
